import { Container } from "react-bootstrap";
import { GrFormNext } from "react-icons/gr";
import { NavLink } from "react-router-dom";

export default function Migas({ ruta }) {

    return (
        <>
            <Container className="content-migas">
                <li>
                    <NavLink to={'/'} >Inicio</NavLink>
                </li>
                <li >
                    <i className="divisor-miga">
                        <GrFormNext className="tamanoicono-divisor-miga" />
                    </i>
                </li>
                <li>
                    <b>{ruta}</b>
                </li>
            </Container>
        </>
    )
}